/**
 * Private Route Component
 * Protège les routes selon:
 * - Authentification (isAuthenticated)
 * - Rôles autorisés (allowedRoles)
 * 
 * IMPORTANT: Ne redirige JAMAIS avant que authLoading soit terminé
 */

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUniversalAuth } from "../../contexts/UniversalAuthContext";

export default function PrivateRoute({ allowedRoles = [] }) {
  const { user, isAuthenticated, authLoading } = useUniversalAuth();
  const location = useLocation();

  // Loading state: afficher loader pendant la validation de session
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Pas authentifié: rediriger vers login avec retour prévu
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  // Vérifier les rôles autorisés
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    console.warn(`User role "${user.role}" not allowed. Required: ${allowedRoles.join(", ")}`);
    return <Navigate to="/auth/login" replace />;
  }

  // Vérifier que le compte est actif
  if (user.status === "disabled") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center max-w-md px-4">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Compte désactivé</h1>
          <p className="text-gray-600 mb-6">
            Votre compte a été désactivé. Contactez un administrateur pour plus d'informations.
          </p>
          <button
            onClick={() => window.location.href = "/auth/login"}
            className="px-4 py-2 bg-gray-900 text-white rounded-lg"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  // CRITIQUE: Vérifier si le changement de mot de passe est obligatoire
  // Seule exception: la route de changement de mot de passe elle-même
  if (user.must_change_password && location.pathname !== "/auth/force-change-password") {
    return <Navigate to="/auth/force-change-password" replace state={{ from: location }} />;
  }

  // Autorisé: rendre les routes enfants
  return <Outlet />;
}
